import { createContext } from 'react';

export interface TabsContextType<TValue = unknown> {
  bleed: boolean;
  disabled: boolean;
  plain: boolean;
  setValue: (value: TValue) => void;
  value?: TValue;
}

export const TabsContext = createContext<TabsContextType>({} as TabsContextType);
